import React, { useRef, useEffect, useState } from "react";
import { Box } from "@mui/material";
import "./Marquee.css";

interface MarqueeProps {
  text: string | any;
  speed?: number;
}

const Marquee: React.FC<MarqueeProps> = ({ text, speed = 50 }) => {
  const marqueeRef = useRef<HTMLDivElement>(null);
  const [contentWidth, setContentWidth] = useState(0);

  useEffect(() => {
    // 获取内容的宽度
    if (marqueeRef.current) {
      setContentWidth(marqueeRef.current.offsetWidth);
    }
  }, [text]);

  // 动画时长计算：速度固定为每秒滚动多少像素
  const animationDuration = contentWidth / speed;

  return (
    <Box className="marquee-container">
      <Box
        className="marquee-content"
        ref={marqueeRef}
        style={{
          animationDuration: `${animationDuration}s`, // 动态设置动画时长
        }}
      >
        {/* 两份内容，确保无缝衔接 */}
        <span className="insert-text text-lg" style={{ color: 'white' }} dangerouslySetInnerHTML= {{__html:text}}></span>
        <span className="insert-text text-lg" style={{ color: 'white' }} dangerouslySetInnerHTML= {{__html:text}}></span>
      </Box>
    </Box>
  );
};

export default Marquee;
